//@flow

import classnames from "classnames";
import React, { useState } from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import { HiddenBruImage, YoutubeVideoPlayer } from "@/components";
import ArrowForwardIcon from "@/images/ArrowForward.inline.svg";
import {useCurrentSrcChangeCallback} from "@/utils";

type Props = {
    name: React$Node,
    image?: ImageSharp,
    styleClass?: string,
    link?: {
        path: { publicURL: string },
        text: string,
        target?: string,
    },
    video?: {
        id: string,
        placeholder?: ImageSharp,
        aspectRatio: string,
    },
};

const Hero = ({name, image, styleClass, link, video}: Props): React$Element<"div"> => {
    const [style, setStyle] = useState<any>({});

    const setStyleCallback = useCurrentSrcChangeCallback(setStyle);

    return (
        <div
            className={classnames(
                "hero visual height-md-fluid",
                styleClass,
                video && "hero-video-wrapper",
            )}
            style={style}
        >
            {image && (
                <HiddenBruImage
                    image={image}
                    onCurrentSrcChange={setStyleCallback}
                />
            )}

            <div className="position-relative">
                {video && (
                    <div
                        style={{
                            aspectRatio: video.aspectRatio.replace(":", "/"),
                        }}
                    >
                        <div className="position-absolute w-100">
                            <YoutubeVideoPlayer
                                id={video.id}
                                aspectRatio={video.aspectRatio}
                                placeholder={video.placeholder?.childImageSharp?.original?.src}
                            />
                        </div>
                    </div>
                )}

                {name && (
                    <div
                        className={classnames(
                            "container",
                            video && "position-absolute top-0",
                        )}
                        style={{ top: 0 }}
                    >
                        <Row className="py-2 py-md-6">
                            <Col
                                md={{ span: 10, offset: 1 }}
                                xl={{ span: 8, offset: 0 }}
                            >
                                <h1 className="h1-mobile-smaller text-white mb-0">
                                    {name}
                                </h1>

                                {link && (
                                    <a
                                        href={link.path.publicURL}
                                        className={
                                            "continue-link boxed-light mt-3 mt-md-4"
                                        }
                                        target={link.target}
                                        rel="noreferrer"
                                        key="A"
                                    >
                                        {link.text}
                                        <div className="svg-box icon-sm transition icon-forward">
                                            <div className="svg-container">
                                                <ArrowForwardIcon />
                                            </div>
                                        </div>
                                    </a>
                                )}
                            </Col>
                        </Row>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Hero;
